import tokens from "../tokens.json";

const theme = {
  colors: tokens.colors,
  typography: tokens.typography,
  spacing: tokens.spacing,
};

export default theme;
